import { RouteConfig } from "vue-router"
import { ROLES } from "@/constants/roles"
import { SEARCH_TYPE } from "@/constants/search-type"

export const adminRoutes: RouteConfig[] = [
    {
        path: "admin",
        component: () => import("@/layouts/Wrapper.vue"),
        meta: {
            title: "Admin",
            permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
            maintainsContext: true,
        },
        redirect: "admin/search",
        children: [
            {
                path: "search",
                component: () => import("@/layouts/Wrapper.vue"),
                meta: {
                    title: "Search",
                    requiresAuth: true,
                    permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                    maintainsContext: true,
                },
                children: [
                    {
                        path: "",
                        name: "AdminSearch",
                        component: () => import("@/views/admin/AdminSearch.vue"),
                        meta: {
                            requiresAuth: true,
                            permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                            maintainsContext: true,
                        },
                    },
                    {
                        path: "users",
                        name: "AdminSearchUsers",
                        component: () =>
                            import("@/components/admin/user-search/AdminSearchUsers.vue"),
                        meta: {
                            title: "Users",
                            showAdminSearch: true,
                            searchType: SEARCH_TYPE.USER,
                            requiresAuth: true,
                            permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                            showBackButton: true,
                            maintainsContext: true,
                        },
                    },
                    {
                        path: "locations",
                        name: "AdminSearchLocations",
                        component: () =>
                            import("@/components/admin/location-search/AdminSearchLocations.vue"),
                        meta: {
                            title: "Locations",
                            showAdminSearch: true,
                            searchType: SEARCH_TYPE.LOCATION,
                            requiresAuth: true,
                            permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                            showBackButton: true,
                            maintainsContext: true,
                        },
                    },
                    {
                        path: "oem-devices",
                        name: "AdminSearchOEMDevices",
                        component: () =>
                            import(
                                "@/components/admin/oem-device-search/AdminSearchOEMDevices.vue"
                            ),
                        meta: {
                            title: "Devices",
                            useDynamicTitle: true,
                            showAdminSearch: true,
                            searchType: SEARCH_TYPE.OEM_DEVICE,
                            requiresAuth: true,
                            permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                            showBackButton: true,
                            maintainsContext: true,
                        },
                    },
                    {
                        path: "devices",
                        name: "AdminSearchDevices",
                        component: () =>
                            import("@/components/admin/device-search/AdminSearchDevices.vue"),
                        meta: {
                            title: "Devices",
                            showAdminSearch: true,
                            searchType: SEARCH_TYPE.DEVICE,
                            requiresAuth: true,
                            permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                            showBackButton: true,
                            maintainsContext: true,
                        },
                    },
                ],
            },
        ],
    },
]
